import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Container, Divider, FormControl, FormLabel, Grid, InputLabel, MenuItem, Paper, Select, TextField, Theme, Typography, createStyles, makeStyles, colors, FormHelperText, CircularProgress } from '@material-ui/core';
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { GADrawing } from '../app/utils/models';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createGADrawingModel, updateGADrawingModel, removeGADrawingModel, getGADrawingModel, getGADrawingModelList, newProjectResponse } from "../app/reducer/gaDrawingModal.reducer";
import { useAppSelector } from "../app/hooks";
import AlertComponent from "../components/general/Alert";
import { FanUploadProps } from './Fans'
import DeleteDialog from './DeleteDialog';
import Paths from '../utils/Paths';
import AlertDialog from './AlertDialog';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGroup: {
      display: 'flex',
      flexDirection: 'row'
    },
    formControl: {
      width: '100%',
    },
    radioWrapped: {
      marginLeft: theme.spacing(2),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    redOutline: {
      borderColor: "red !important"
    },
    uppercaseText: {
      textTransform: 'uppercase'
    }
  }),
);

enum InputFieldsName {
  GaDrawingBandId,
  BladeType,
  NoOfBlades,
  TaperBushType
}

enum ButtonName {
  Edit,
  Duplicate,
  Delete,
  Submit,
  Back,
  PartialBack,
  SelectFile,
  PartialUpdate
}
enum UserAction {
  View,
  Edit,
  Delete,
  Duplicate
}

const ButtonVisibleConfig = {
  [UserAction.View]: [ButtonName.Edit, ButtonName.Delete, ButtonName.Duplicate, ButtonName.Back, ButtonName.PartialUpdate],
  [UserAction.Edit]: [ButtonName.Submit, ButtonName.PartialBack, ButtonName.SelectFile],
  [UserAction.Duplicate]: [ButtonName.PartialBack, ButtonName.Submit, ButtonName.SelectFile],
  [UserAction.Delete]: [ButtonName.Edit, ButtonName.Delete, ButtonName.Duplicate, ButtonName.Back],
}

const InputFieldsEnableConfig: any = {
  [UserAction.View]: [InputFieldsName.BladeType, InputFieldsName.NoOfBlades, InputFieldsName.TaperBushType],
  [UserAction.Edit]: [InputFieldsName.GaDrawingBandId],
  [UserAction.Duplicate]: [],
  [UserAction.Delete]: [],
}

export default function GADrawings({ setIndex, gaDrawingID, setVisibleModule, isFromFanList, footerDisable , selectedFan}: FanUploadProps) {

  console.log("selectedFan",selectedFan)
  const { register, handleSubmit, setValue, getValues, control, formState: { errors }, setError, reset } = useForm<GADrawing>();
  const classes = useStyles();
  const dispatch = useDispatch()
  const history = useHistory();

  const [value, setSelectedValue] = useState<string | null>(null);
  const [inputValue, setInputValue] = useState('');
  const [bladeModels, setBladeModels] = useState<any[] | undefined>([]);
  const [options, setOptions] = useState<string[]>([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [buttonAction, setButtonAction] = useState<string>('Edit');
  const [openAlert, setOpenAlert] = React.useState<boolean>(false);
  const [openAlertMesage, setOpenAlertMessage] = React.useState<string>("");
  const [file, setFile] = useState<any | null>("");
  const [openErrorAlert, setOpenErrorAlert] = React.useState<boolean>(false);
  const [openErrorAlertMesage, setOpenErrorAlertMessage] = React.useState<string>("");
  const [drawingList, setDrawingList] = React.useState<any>([]);
  const [duplicatedDrawingId, setDuplicatedDrawingId] = useState("");
  const [warningDialog, setWarningDialog] = useState(false);
  const [warningDialogText, setWarningDialogText] = useState("");
  const [loading, setLoading] = useState(false);

  const [userAction, setUserAction] = useState(UserAction.View);


  const modelList = useAppSelector(getGADrawingModelList);
  const newProjectResponses = useAppSelector(newProjectResponse);

  const cache: any = {};
  const memoizedGetBladeModels = async () => {
    if (cache.bladeModels) {
      return cache.bladeModels;
    }
    const bladeModels = await dispatch(getGADrawingModel());
    cache.bladeModels = bladeModels;

    return bladeModels;
  };

  const fetchUpdatedData = async () => {
    const bladeModels = await memoizedGetBladeModels();
    const modelList = bladeModels.payload.data
    setBladeModels(modelList)
    const options = modelList ? modelList.map((item: any) => item?.gaDrawingID) : [];
    setDrawingList([...options])
    setOptions(options.sort())
  }
  const miniRefresh = async () => {
    setLoading(true);
    const bladeModels: any = await dispatch(getGADrawingModel());
    const { newValues, selectedItem } = updateNewValuesAftreRefresh(gaDrawingID, bladeModels.payload.data);
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
    setBladeModels(bladeModels.payload.data);
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    (async () => {
      if (setIndex) {
        setIndex(4);
      }
      await fetchUpdatedData(); // Wait for fetchUpdatedData to complete
      if (gaDrawingID) {
        setSelectedValue(gaDrawingID);
        const { newValues, selectedItem } = updateNewValues(gaDrawingID);
        Object.keys(newValues).forEach((fieldName: any) => {
          setValue(fieldName, selectedItem[fieldName]);
        });
      }
      setLoading(false);
    })();
  }, []);

  const updateNewValuesAftreRefresh = (inputValue: any, bladeModels: any) => {
    const selectedItem = bladeModels && bladeModels?.find((item: any) => item.gaDrawingID == inputValue)
    if (!bladeModels?.length || !selectedItem) {
      return { newValues: {}, selectedItem: {} };
    }
    const newValues: any = {
      gaDrawingID: selectedItem.gaDrawingID,
      bladeType: selectedItem.bladeType,
      numofBlades: selectedItem.numofBlades,
      taperBushType: selectedItem.taperBushType,
    };
    if (selectedItem.imagePath && selectedItem.imagePath.length > 0)
      setFile(selectedItem.imagePath)
    return { newValues: newValues, selectedItem: selectedItem };
  }


  const updateNewValues = (inputValue: any) => {
    const selectedItem = bladeModels && bladeModels?.find(item => item.gaDrawingID == inputValue)
    console.log({
      bladeModels: bladeModels,
      selectedItem: selectedItem
    })
    if (!bladeModels?.length || !selectedItem) {
      return { newValues: {}, selectedItem: {} };
    }

    const newValues: any = {
      gaDrawingID: selectedItem.gaDrawingID,
      bladeType: selectedItem.bladeType,
      numofBlades: selectedItem.numofBlades,
      taperBushType: selectedItem.taperBushType,
    };
    if (selectedItem.imagePath && selectedItem.imagePath.length > 0)
      setFile(selectedItem.imagePath)
    return { newValues: newValues, selectedItem: selectedItem };
  }


  const handleAddNewItem = () => {
    if (inputValue.trim() && !options.includes(inputValue)) {
      setOptions([...options, inputValue]);
      setSelectedValue(inputValue);
    }
    if (options.length == 0) {
      fetchUpdatedData();
    }
  };

  const createDuplicateGaDrawingData = (inputValue: any, data: any) => {
    const selectedItem = bladeModels && bladeModels?.find(item => item.gaDrawingID == duplicatedDrawingId)
    if (!bladeModels?.length || !selectedItem) {
      return {};
    }
    const newValues: any = {
      gaDrawingID: inputValue,
      clampType: selectedItem.clampType,
      clampMaterial: selectedItem.clampMaterial,
      bladeType: data.bladeType,
      taperBushType: data.taperBushType,
      numofBlades: data.numofBlades,
      imagePath: file,
    };
    return newValues;
  }

  const onSubmit: SubmitHandler<GADrawing> = async data => {
    let newData = { ...data, gaDrawingID: inputValue };
    if (file.length > 0)
      newData.imagePath = file;
    if (newData.gaDrawingID != "") {
      if (buttonAction == "Edit") {
        await dispatch(updateGADrawingModel(newData));
        setOpenAlertMessage('GA Drawing data updated successfully')
        // setSelectedFile(null);
        // setFile("");
        reset();
        // setSelectedValue('');
      } else {
        if (drawingList.includes(inputValue) && userAction == UserAction.Duplicate)
          return;
        if (userAction === UserAction.Duplicate) {
          await dispatch(createGADrawingModel(createDuplicateGaDrawingData(inputValue, data)));
        }
        else {
          await dispatch(createGADrawingModel(newData));
        }
        if (!newProjectResponses) {
          setOpenAlertMessage('GA Drawing created successfully');
          // setSelectedFile(null);
          // setFile("");
          reset();
          // setSelectedFile(null);
          // setFile("");
          // setSelectedValue('');
        }

      }
      setOpenAlert(true);
    }
  };


  function disableParentFooter() {
    if (isFromFanList)
      footerDisable(true)
  }

  function enableParentFooter() {
    if (isFromFanList)
      footerDisable(false)
  }

  const onInputChange = (event: any, newInputValue: any, reason: string) => {
    // + If the reason is clear (Default Material UI Event Parameter), reset the input, file, selected file and form values.
    if (reason === "clear" && userAction !== UserAction.Duplicate) {
      setInputValue(newInputValue);
      setFile("");
      setSelectedFile(null);
      reset();
      return;
    }

    setInputValue(newInputValue);
    // if (setVisibleModule) {
    //   setVisibleModule(newInputValue);
    // }
    if (!bladeModels && !inputValue) {
      return false;
    }
    const { newValues, selectedItem } = updateNewValues(newInputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }

  const editField = () => {
    // if (gaDrawingID) {
    //   history.push('/ga-drawings')
    // }
    if (inputValue.length <= 0) {
      setWarningDialog(true);
      setWarningDialogText("Please select a GADrawing ID for edit.")
      return;
    }
    disableParentFooter();
    setUserAction(UserAction.Edit);
    setButtonAction("Edit");
    setDuplicatedDrawingId(inputValue);
    console.log("Edit", bladeModels, inputValue)
    if (!bladeModels && !inputValue) {
      return false;
    }
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }

  const duplicateField = () => {
    if (inputValue.length <= 0) {
      setWarningDialog(true);
      setWarningDialogText("Please select a GADrawing ID to duplicate.")
      return;
    }
    setUserAction(UserAction.Duplicate);
    setButtonAction("Duplicate");
    if (!bladeModels && !inputValue) {
      return false
    }
    setDuplicatedDrawingId(inputValue);
    // setSelectedValue('');
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }


  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (inputValue === null || inputValue === undefined || inputValue === "") {
      setWarningDialog(true);
      setWarningDialogText("Please select a GADrawing ID for deletion.")
      return
    }
    setOpen(true);
  };

  const refresh = async () => {
    if (gaDrawingID) {
      await miniRefresh();
      setUserAction(UserAction.View);
      enableParentFooter();
      return;
    }
    fetchUpdatedData();
    history.go(0);
  }
  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    handleClose();
    setOpenAlertMessage('Deleted GA Drawing successfully');
    setOpenAlert(true);
  };

  const onDelete = async () => {
    setButtonAction("Delete");
    if (!bladeModels && !inputValue) {
      return false
    }
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
    await dispatch(removeGADrawingModel(newValues));
    setOpenAlertMessage('GA Drawing successfully');
    setOpenAlert(true);
  }

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event: any) => {
    const selectedFile = event.target.files[0];
    // ++ Restrict file size to 5 MB or less.
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes.
    if (selectedFile.size > maxSize) {
      setOpenErrorAlertMessage("Image size must be less than 5 MB.");
      setOpenErrorAlert(true);
      return;
    }
    setSelectedFile(selectedFile.name)
    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onloadend = () => {
      setFile(reader.result);
    };
  };

  const handleUpload = () => {
    // Handle file upload logic here
    if (selectedFile) {
      console.log('Selected file:', selectedFile);
      // You can perform file upload logic here, such as sending the file to a server
    } else {
      console.log('No file selected');
    }
  }

  const isTextFieldEnable = (name: InputFieldsName): boolean => {
    return InputFieldsEnableConfig[userAction].includes(name);
  }

  const isButtonVisible = (name: ButtonName): boolean => {
    return ButtonVisibleConfig[userAction].includes(name);
  }

  const isPartialButtonVissible = (): any => {
    return isFromFanList && isButtonVisible(ButtonName.PartialUpdate);
  }

  const onPartialUpdate = () => {
    if (setVisibleModule && inputValue) {
      setVisibleModule(inputValue);
      setWarningDialog(true);
      setWarningDialogText("New GA Drawing Updated.")
    }
  }

  const viewIn3D = () => {
    if(selectedFan.fanModelID){
      const url = 'https://main.d21het1hwiprnz.amplifyapp.com/?fanModelID='+selectedFan.fanModelID;
      window.open(url, '_blank');
    }
  }


  return (
    <div className="page-wrapper">
      <Container maxWidth="xl">
        <Paper className="form-wrapper">
          <Typography variant="h5" gutterBottom>
            <b className={classes.uppercaseText}>{buttonAction} GA Drawing Details</b>
          </Typography>
          <hr />
          <Divider />
          <AlertDialog open={warningDialog} message={warningDialogText} handleClose={() => setWarningDialog(false)} />
          <AlertDialog open={openAlert} message={openAlertMesage} handleClose={() => { setOpenAlert(false); refresh(); }} />
          <AlertComponent open={openErrorAlert} message={openErrorAlertMesage} severity="error" handleClose={() => { setOpenErrorAlert(false) }} />
          <DeleteDialog open={open} handleClose={handleClose} path={Paths.GaDrawing} idType="gaDrawingID" id={inputValue} handleDelete={handleDelete} />
          <form id="fan-details-form" style={{ padding: '5px' }} onSubmit={handleSubmit(onSubmit)}>
            {((!inputValue || drawingList.includes(inputValue)) && buttonAction == 'Duplicate') && (
              <p className="MuiFormHelperText-root MuiFormHelperText-contained" style={{ color: 'red' }}>Add new GA Drawing</p>
            )}
            {inputValue && buttonAction == 'Duplicate' && newProjectResponses?.error?.errors[0].bladeModel && (
              <p className="MuiFormHelperText-root MuiFormHelperText-contained" style={{ color: 'red' }}>{newProjectResponses?.error?.errors[0].bladeModel}</p>
            )}

            <Grid container spacing={4}>
              <Grid item xs={12} lg={4}>
                <Autocomplete
                  disabled={isTextFieldEnable(InputFieldsName.GaDrawingBandId)}
                  style={{ width: '260px' }}
                  value={value}
                  inputValue={inputValue}
                  onInputChange={onInputChange}
                  options={options}
                  freeSolo
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      label="Select or add new GA Drawing ID"
                      variant="outlined"
                    />
                  )}

                  onBlur={handleAddNewItem}
                  onKeyDown={(event: any) => {
                    if (event.key === 'Enter') {
                      handleAddNewItem();
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} lg={2}>
                {isButtonVisible(ButtonName.Edit) &&

                  <Button variant="contained" color="primary" onClick={editField} style={{
                    width: '150px',
                    backgroundColor:'#10B981',
                    marginLeft: (gaDrawingID ? "140px" : "70px")
                  }}>EDIT</Button>

                }
              </Grid>


              {
                (gaDrawingID && isButtonVisible(ButtonName.Submit)) && (
                  <Grid item xs={12} lg={3}>
                    <Button variant="contained" color="primary" type='submit'>{buttonAction} Submit</Button>
                  </Grid>
                )
              }
              <Grid item xs={12} lg={1}></Grid>
              {
                isPartialButtonVissible() && (
                  <Grid item xs={12} lg={2}>
                    <Button variant="contained" color="secondary" type='button' onClick={onPartialUpdate} style={{ color:'white', marginLeft: "100px" }}>Update</Button>
                  </Grid>)
              }

              {isButtonVisible(ButtonName.PartialBack) &&
                <Grid item xs={12} lg={2}>
                  <Button variant="contained" style={{backgroundColor:'#3B82F6'}} color="primary" onClick={() => {
                    setButtonAction("Edit");
                    setUserAction(UserAction.View)
                    if (userAction === UserAction.Duplicate) {
                      setInputValue(duplicatedDrawingId);
                      onInputChange(null, duplicatedDrawingId, "REFRESH")
                    }
                    if (userAction === UserAction.Edit) {
                      onInputChange(null, duplicatedDrawingId, "REFRESH")
                    }
                    enableParentFooter();
                  }} >Back</Button>
                </Grid>
              }
              {!gaDrawingID &&
                <>
                  {isButtonVisible(ButtonName.Duplicate) &&
                    <Grid item xs={12} lg={2}>
                      <Button variant="contained" color="secondary" style={{ color:'white', backgroundColor: '#3B82F6', width: '150px' }} onClick={duplicateField}>DUPLICATE</Button>
                    </Grid>
                  }
                  {isButtonVisible(ButtonName.Delete) &&
                    <Grid item xs={12} lg={2}>
                      <Button variant="contained" color="secondary" style={{ color:'white', backgroundColor: '#EF4444', width: '150px' }} onClick={handleOpen}>DELETE</Button>
                    </Grid>
                  }
                </>
              }

            </Grid>

            <Grid container spacing={3}>

              <Grid item xs={12} lg={4}>

                <FormControl variant="outlined" className={classes.formControl} >
                  <InputLabel>Blade Type</InputLabel>
                  <Controller
                    control={control}
                    name="bladeType"
                    defaultValue="axial"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        disabled={isTextFieldEnable(InputFieldsName.BladeType)}
                        label="blate Type"
                        value={value}
                        {...register("bladeType", { required: true })}
                      >
                        <MenuItem value="C-type">C-Type</MenuItem>
                        <MenuItem value="U-Type">U-Type</MenuItem>
                        <MenuItem value="V-Type">V-Type</MenuItem>
                      </Select>
                    )}
                  />
                  <FormHelperText>{errors.taperBushType ? 'This field is required' : ''}</FormHelperText>
                </FormControl>

              </Grid>
              <Grid item xs={12} lg={4}>
                <TextField
                  disabled={isTextFieldEnable(InputFieldsName.NoOfBlades)}
                  InputLabelProps={{ shrink: true }}
                  label="No. of Blades"
                  variant="outlined" fullWidth
                  {...register("numofBlades", { required: true })}
                  helperText={errors.numofBlades ? 'This field is required' : ''}
                />
              </Grid>


              <Grid item xs={12} lg={4}>
                <TextField
                  disabled={isTextFieldEnable(InputFieldsName.TaperBushType)}
                  InputLabelProps={{ shrink: true }}
                  label="Taper Bush Type"
                  variant="outlined" fullWidth
                  {...register("taperBushType", { required: true })}
                  helperText={errors.taperBushType ? 'This field is required' : ''}
                />
              </Grid>
            </Grid>


            <Grid container spacing={3} alignItems="center">
              {isButtonVisible(ButtonName.SelectFile) && (
                <>
                  <Grid item>
                    <input
                      accept="image/*" // Define accepted file types
                      id="file-upload" // Unique ID for the input element
                      type="file" // Input type is set to 'file' for file uploads
                      style={{ display: 'none' }} // Hide the default file input
                      onChange={handleFileChange} // Handle file selection
                    />
                    <label htmlFor="file-upload">
                      <Button variant="contained" component="span"> {/* Button to trigger file selection */}
                        Choose File
                      </Button>
                    </label>
                  </Grid>
                  <Grid item>
                    <Typography variant="body1">
                      {selectedFile ? selectedFile : 'No file selected'}
                    </Typography>
                  </Grid>
                </>
              )
              }
              {
                file &&
                <Grid item>
                  <Paper elevation={3} style={{ padding: 20 }}>
                    <img src={file} style={{ maxWidth: '100%', height: '200px' }} />
                  </Paper>

                </Grid>

              }

              <Grid item>

                <label htmlFor="file-upload">
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    disabled={true}
                    // style={{backgroundColor: 'rgb(245, 154, 36)' }}
                    onClick={viewIn3D}
                  >
                    View in 3D
                  </Button>
                </label>
              </Grid>
            </Grid>

            {!gaDrawingID &&
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                {isButtonVisible(ButtonName.Submit) &&
                  <Grid item xs={12} lg={12}>
                    <Button variant="contained" style={{ color:'white',backgroundColor:'#10B981' }}type='submit'>{buttonAction} Submit</Button>
                  </Grid>
                }
                {isButtonVisible(ButtonName.Back) &&
                  <Grid item xs={12} lg={12}>
                    <Button style={{ color:'white', backgroundColor:'#6b6666', fontSize:'20px'}} variant="contained" color="primary" type='button' onClick={() => history.goBack()}>Back</Button>
                  </Grid>
                }
              </Grid>
            }
          </form>
        </Paper>


        <Dialog open={loading} aria-labelledby="delete-dialog-title">
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>
      </Container>
    </div>
  );

}


